/**
 * Confirmación de anulación de un pedido de venta, con motivo obligatorio.
 *
 * La usan el listado y el detalle. Anular no tiene vuelta atrás y el motivo es
 * lo único que explica después por qué el pedido quedó anulado, así que no se
 * puede confirmar en blanco (revisión QA 2026-10, M02-VC-22). El backend
 * también lo exige.
 */
import { useState } from 'react'
import { Modal } from '@/components/ds/Modal'

interface Props {
  orderNumber: string
  isPending: boolean
  onConfirm: (reason: string) => void
  onClose: () => void
}

export function AnularPedidoDialog({ orderNumber, isPending, onConfirm, onClose }: Props) {
  const [reason, setReason] = useState('')
  const motivo = reason.trim()

  return (
    <Modal
      open
      onClose={onClose}
      title={`Anular pedido ${orderNumber}`}
      size="sm"
      dismissOnScrimClick={false}
      actions={<>
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm text-content-muted border border-divider rounded-lg hover:bg-soft"
        >
          Volver
        </button>
        <button
          onClick={() => onConfirm(motivo)}
          disabled={isPending || !motivo}
          className="px-4 py-2 text-sm font-medium text-white bg-danger-fill rounded-lg hover:bg-danger-fill-hover disabled:opacity-50"
        >
          {isPending ? 'Anulando…' : 'Anular pedido'}
        </button>
      </>}
    >
      <div className="space-y-2">
        <p className="text-sm text-content-muted">
          Esta acción no se puede deshacer. El motivo queda registrado en el pedido.
        </p>
        <label htmlFor="anular-pedido-motivo" className="block text-sm font-medium text-content">
          Motivo de la anulación *
        </label>
        <textarea
          id="anular-pedido-motivo"
          value={reason}
          onChange={e => setReason(e.target.value)}
          rows={3}
          maxLength={500}
          autoFocus
          className="w-full px-3 py-2 text-sm border border-input-border rounded-lg bg-input-bg text-content focus:outline-none focus:ring-2 focus:ring-danger-border resize-none"
        />
      </div>
    </Modal>
  )
}
